//import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./Header.css";

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper";

export default function Header() {
  return (
    <>
      <Swiper
        spaceBetween={0}
        centeredSlides={true}
        autoplay={{
          delay: 4500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        <SwiperSlide>

<section id="home" data-stellar-background-ratio="0.5">
          <div class="container">
               <div class="row">
                    <div class="col-md-6 col-sm-12"><br /><br />
                         <div class="home-info">
                              <h1>WE OFFER <b>QUALITY EDUCATION </b> FOR ALL STUDENTS.</h1>
                              <span>
                                   Our goal is to make formal education
                                   <small>accessible to everyone</small>
                              </span>

                              <div className='hm-bg-bt-section'>
                              <a href="/account" className="btn smoothScroll">
                                   <button type="button" class="rounded-pill btn-rounded btn border-primary" >Join Us
                                   <span><i class="fas fa-arrow-right"></i></span>
                                   </button>
                              </a>
                              <a href="#about" class="btn smoothScroll">
                                   <button type="button" class="rounded-pill btn-rounded btn border-primary" >Learn More
                                   <span><i class="fa-solid fa-circle-info"></i></span>
                                   </button>
                              </a>
                              </div>
                         </div>
                    </div>
                    

                    
                    
               </div>
          </div>     
</section>

		</SwiperSlide>

		{/* Slide 2*/}

        <SwiperSlide>

		<section id="home2" data-stellar-background-ratio="0.5">
          <div class="overlay"></div>
          <div class="container">
               <div class="row">
               

                    <div class="col-md-6 col-sm-12"><br /><br />
                         <div class="home-info">
                         <h1>WE OFFER <b>QUALITY EDUCATION </b>FOR ALL STUDENTS.</h1>
                              <span>
                                   Our goal is to make formal education
                                   <small>accessible to everyone</small>
                              </span>

                              <div className='hm-bg-bt-section'>
                              <a href="/login-page" className="btn smoothScroll">
                                   <button type="button" class="rounded-pill btn-rounded btn border-primary" >Join Us
                                   <span><i class="fas fa-arrow-right"></i></span>
                                   </button>
                              </a>
                              <a href="#about" class="btn smoothScroll">
                                   <button type="button" class="rounded-pill btn-rounded btn border-primary" >Learn More
                                   <span><i class="fa-solid fa-circle-info"></i></span>
                                   </button>
                              </a>
                              </div>
                         </div>
                    </div>
                    

                    
                    
               </div>
          </div>     
</section>

		</SwiperSlide>


		{/* Slide 3*/}
        <SwiperSlide><section id="home3" data-stellar-background-ratio="0.5">
          <div class="overlay"></div>
          <div class="container">
               <div class="row">
               

                    <div class="col-md-6 col-sm-12"><br /><br />
                         <div class="home-info">
                         <h1><b>LIBRARY</b> FACILITY <b>TO</b> ENHANCE <b> ALL</b> READ AND WRITE<b>.</b></h1>
                              <span>
                                   Our goal is to make formal education
                                   <small>accessible to everyone</small>
                              </span>

                              <div className='hm-bg-bt-section'>
                              <a href="/login-page" className="btn smoothScroll">
                                   <button type="button" class="rounded-pill btn-rounded btn border-primary" >Join Us
                                   <span><i class="fas fa-arrow-right"></i></span>
                                   </button>
                              </a>
                              <a href="#about" class="btn smoothScroll">
                                   <button type="button" class="rounded-pill btn-rounded btn border-primary" >Learn More
                                   <span><i class="fa-solid fa-circle-info"></i></span>
                                   </button>
                              </a>
                              </div>
                         </div>
                    </div>
                    

                    
                    
               </div>
          </div>     
</section>
</SwiperSlide>

        {/* Slide 4*/}

        <SwiperSlide>

		<section id="home4" data-stellar-background-ratio="0.5">
          <div class="overlay"></div>
          <div class="container">
               <div class="row">
               

                    <div class="col-md-6 col-sm-12"><br /><br />
                         <div class="home-info">
                         <h1><b>WE</b> OFFER <b>QUALITY</b> EDUCATION FOR <b> ALL</b> STUDENTS<b>.</b></h1>
                              <span>
                                   Our goal is to make formal education
                                   <small>accessible to everyone</small>
                              </span>

                              <div className='hm-bg-bt-section'>
                              <a href="/login-page" className="btn smoothScroll">
                                   <button type="button" class="rounded-pill btn-rounded btn border-primary" >Join Us
                                   <span><i class="fas fa-arrow-right"></i></span>
                                   </button>
                              </a>
                              <a href="#about" class="btn smoothScroll">
                                   <button type="button" class="rounded-pill btn-rounded btn border-primary" >Learn More
                                   <span><i class="fa-solid fa-circle-info"></i></span>
                                   </button>
                              </a>
                              </div>
                         </div>
                    </div>
                    

                    
                    
               </div>
          </div>     
</section>

		</SwiperSlide>
        
      </Swiper>
    </>
  );
}
